import { ChangeDetectorRef, Component, EventEmitter, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, Subject, first, config, isEmpty, shareReplay } from 'rxjs'; import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { ActivatedRoute } from '@angular/router';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import exifr from 'exifr';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-epc-work-pv',
  templateUrl: './epc-work-pv.component.html',
  styleUrls: ['./epc-work-pv.component.scss']
})
export class EpcWorkPvComponent implements OnInit {

  public userId: any;

  // public hideGetDataButton: boolean = false;

  public contractorOutletList: any = [];
  public selectedOutletToGetData: any;
  public selectedBenefitedAreaToGetData: any;

  public agreementNoList: any = [];
  public agreementNoToGetData: any;

  public chunkList: any = [];
  public chunkIdToGetData: any;

  public epcDataForApproval: any = [];
  public epcDataForAppLandDetails: any = [];

  public showActionDialog: boolean = false;

  public estimationDataForApproval: any = [];

  public clonedProducts: { [s: string]: any } = {};

  public selectedJE: any;
  public selectedStatus: any;
  public remarks: any;
  public items: any = [];
  public jeList: any = [];

  public appStatusTypeList: any = [];
  public selectedAppStatus: any;

  public selectedFarmerApp: any;

  public ipAddress: any = '000.000.000';
  public subscriptions: any = [];
  public subjectSub: any;
  public displayCameraComponent: boolean = false;
  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();


  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId!: string;
  public pictureTaken = new EventEmitter<WebcamImage>();
  public webcamImage!: WebcamImage;
  // public videoOptions: MediaTrackConstraints = {};
  public videoOptions: MediaTrackConstraints = {
    width: { ideal: this.viewportToPixels('100vw') },
    height: { ideal: 500 },
  };
  public imageCaptured = false;
  public errors: WebcamInitError[] = [];


  // public attachmentsList: any = [];
  // public activeIndex: number = 0;
  // public displayCustom: boolean;

  // public responsiveOptions: any[] = [
  //   {
  //     breakpoint: '1024px',
  //     numVisible: 5
  //   },
  //   {
  //     breakpoint: '768px',
  //     numVisible: 3
  //   },
  //   {
  //     breakpoint: '560px',
  //     numVisible: 1
  //   }
  // ];

  public geolocationsarray: any = [];
  public overlays: any = [];
  public mapEnable = false;

  options = {
    center: { lat: 29.0588, lng: 76.0856 },
    zoom: 17,
    mapTypeId: google.maps.MapTypeId.SATELLITE,
    draggable: true,
    // icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
  };

  public landArea: number = 0;
  public surveyArea: number = 0;
  public coordinateError: any;
  public isGPSError: boolean = false;

  public refreshLocation: any;

  public imageError: string;
  public uploadOptions: any[];
  public documentList: any = [];
  public selctedFileType: any;
  // public isPVSurveySubmitted: boolean = false;

  public isJELogin: boolean = false;
  public isXENLogin: boolean = false;

  public geoLocMulArray: any[] = [];

  constructor(
    private loader: AppLoaderService,
    private fApplicationService: FarmersApplicationService,
    private messageService: MessageService,
    private vendorService: VendorDashboardService,
    private deptDashBoardService: DepartmentDashboardService,
    private ipService: IpAddressService,
    private route: ActivatedRoute,
    private _personalDetalSer: FarmersDetailsService,
    private activityRecordService: ActivityRecordService,
    private cryptoJsService: CryptoJsService,
    private cdr: ChangeDetectorRef
  ) {
    (this.uploadOptions = [
      { name: 'Farmer Photo', code: 'farmer_photo' },
      { name: 'Water Source', code: 'water_source' },
      { name: 'Land Photo', code: 'land_photo' },
      { name: 'Others', code: 'others' },
    ]);
  }

  ngOnInit(): void {
    this.getIP();
    this.getJEList();
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    const tokenData = sessionStorage.getItem('token')
      ? JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')))
      : {};
    if (tokenData && (tokenData.role == 'JE' || tokenData.role == 'CJE')) {
      this.isJELogin = true;
    }
    if (tokenData && (tokenData.role == 'XEN' || tokenData.role == 'CXEN')) {
      this.isXENLogin = true;
    }

    this.getAppStatusTypeList();
    this.getStatusList();
  }

  getAppStatusTypeList() {
    setTimeout(() => {
      this.appStatusTypeList = [
        {
          status_Code: 1,
          status_Description: 'Pending'
        },
        // {
        //   status_Code: 2,
        //   status_Description: 'Current'
        // },
        {
          status_Code: 3,
          status_Description: 'Approved'
        }
      ]
    }, 200)
  }

  getJEList() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    // this.loader.start();
    this.deptDashBoardService
      .getJEUserIds(JSON.parse(payload)?.sub)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.jeList = data;
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'success',
          //   summary: 'Success Message',
          //   detail: data.toString(),
          // });
        },
        error: (err) => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Next level user not found. ${err}`,
          });
        },
      });
  }

  getStatusList() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    // this.loader.start();
    this.deptDashBoardService
      .getStatusMasterEPC(JSON.parse(payload)?.sub)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.items = data.$values;
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'success',
          //   summary: 'Success Message',
          //   detail: data.toString(),
          // });
        },
        error: () => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Status Master cant be Loaded',
          });
        },
      });
  }

  getContractorOutletList(contractorId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getOutletByContractor(contractorId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.contractorOutletList = res;
        },
        error: (err) => {
          this.loader.close();
          this.contractorOutletList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectAppStatus() {
    this.clearAllData();

    this.getContractorOutletList(0, this.userId, this.selectedAppStatus?.status_Description);

  }

  onSelectOutletToGetData() {
    this.agreementNoList = [];
    this.agreementNoToGetData = null;

    this.chunkList = [];
    this.chunkIdToGetData = null;

    this.epcDataForApproval = [];
    this.epcDataForAppLandDetails = [];
    this.estimationDataForApproval = [];

    this.selectedJE = null;
    this.selectedStatus = null;
    this.remarks = null;

    this.selectedBenefitedAreaToGetData = this.selectedOutletToGetData?.CCA_A;

    let conId = this.selectedOutletToGetData?.ContractorCode;
    let outletId = this.selectedOutletToGetData?.OutletId;
    let status = this.selectedAppStatus?.status_Description;
    this.getAgreementNumberList(conId, outletId, this.userId, status);
  }

  getAgreementNumberList(contractorId, outletId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getAgreementByContractor(contractorId, outletId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.agreementNoList = res;
        },
        error: (err) => {
          this.loader.close();
          this.agreementNoList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectAgreementNo() {
    this.chunkList = [];
    this.chunkIdToGetData = null;

    this.epcDataForApproval = [];
    this.epcDataForAppLandDetails = [];
    this.estimationDataForApproval = [];

    this.selectedJE = null;
    this.selectedStatus = null;
    this.remarks = null;

    let outletId = this.selectedOutletToGetData?.OutletId;
    let contractorId = this.selectedOutletToGetData?.ContractorCode;
    let agreementNo = this.agreementNoToGetData?.AgreementNo;
    let status = this.selectedAppStatus?.status_Description;

    this.getChunkIdsList(contractorId, agreementNo, outletId, this.userId, status);
  }

  getChunkIdsList(contractorId, agreementNo, outletId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getChunkIds(contractorId, agreementNo, outletId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if (res.length > 0) {
            this.chunkList = res.map(val => ({
              ...val,
              combineData: `${val?.ChunkId}. ${val?.FarmerName} (${val?.AppId})`
            }));
          } else {
            this.chunkList = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data not found',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.chunkList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onClickGetFarmerData() {
    this.epcDataForApproval = [];
    this.epcDataForAppLandDetails = [];
    this.estimationDataForApproval = [];

    this.selectedJE = null;
    this.selectedStatus = null;
    this.remarks = null;

    let outletId = this.selectedOutletToGetData?.OutletId;
    let contractorId = this.selectedOutletToGetData?.ContractorCode;
    let agreementNo = this.agreementNoToGetData?.AgreementNo;
    let chunkId = this.chunkIdToGetData?.ChunkId;

    if (outletId && agreementNo) {
      this.getEPCFarmerDetails(agreementNo, outletId, chunkId);
      this.getEPCEstimationDetails(contractorId, outletId, agreementNo, chunkId);
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Select Outlet and Fill Agreement Number.',
      });
    }
  }

  getEPCFarmerDetails(agreementNo, outletId, chunkId) {
    this.loader.start();
    this.vendorService
      .getEPCDetails(agreementNo, outletId, chunkId, this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          let resp: any = data;
          if (resp?.otherDetails['$values'].length > 0) {
            this.epcDataForApproval = resp?.otherDetails['$values'];
            this.epcDataForAppLandDetails = resp?.landDetails['$values'];
          } else {
            this.epcDataForApproval = [];
            this.epcDataForAppLandDetails = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For PV (Farmer)', `${agreementNo}, ${outletId}, ${chunkId}`, new Date(), `${data}`);
        },
        error: (err) => {
          this.epcDataForApproval = [];
          this.epcDataForAppLandDetails = [];

          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For PV Error(Farmer)', `${agreementNo}, ${outletId}, ${chunkId}`, new Date(), `${err}`);
        },
      });
  }

  getEPCEstimationDetails(contractorId, outletId, agreementNo, chunkId) {
    this.loader.start();
    this.vendorService
      .getContractorEstimation(contractorId, outletId, agreementNo, chunkId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          let resp: any = data;
          if (resp.length > 0) {
            this.estimationDataForApproval = resp.map((val) => ({
              ...val,
              id: `${val?.ProgramID}_${val?.catId}_${val?.ComponentID}`,
              jeQuantity: val?.Quantity ? val?.Quantity : 0,
              jeRemarks: val?.JERemarks ? val?.JERemarks : null
            }));
          } else {
            this.estimationDataForApproval = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For PV (Estimation)', `${contractorId}, ${agreementNo}, ${outletId}, ${chunkId}`, new Date(), `${data}`);
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For PV Error(Estimation)', `${contractorId}, ${agreementNo}, ${outletId}, ${chunkId}`, new Date(), `${err}`);
        },
      });

  }

  onRowEditInit(product: any) {
    this.clonedProducts[product.id as string] = { ...product };
  }

  onRowEditSave(product: any) {
    if (product.jeQuantity > 0 && product.jeQuantity <= product.Quantity) {
      delete this.clonedProducts[product.id as string];
      // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Price is updated' });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid Quantity' });
      return;
    }
  }

  onRowEditCancel(product: any, index: number) {
    this.estimationDataForApproval[index] = this.clonedProducts[product.id as string];
    delete this.clonedProducts[product.id as string];
  }

  onClickSubmit() {
    if(this.epcDataForApproval.length == 0){
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Farmer details not found.' });
      return;
    }

    if (this.estimationDataForApproval.some(val => !(val.jeQuantity > 0 && val.jeQuantity <= val.Quantity))) {
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Please fill all the qunatities properly.' });
      return;
    }

    if (this.epcDataForApproval.some(val => (val.SurveyStatus == 0))) {
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Please physically Verify all the mentioned farmer.' });
      return;
    }

    // if(this.selectedJE == null || this.selectedJE == undefined){
    //   this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Select next level user.' });
    //   return;
    // }

    if (this.selectedStatus?.flag == 'A' && (this.remarks == undefined || this.remarks == "")) {
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Add Remark' });
      return;
    }

    let reqBody = [
      {
        outletId: this.selectedOutletToGetData?.OutletId,
        agreementNo: this.agreementNoToGetData?.AgreementNo,
        conId: this.selectedOutletToGetData?.ContractorCode,
        ChunkId: this.chunkIdToGetData?.ChunkId,
        status: this.selectedStatus?.flag,
        remarks: this.remarks,
        userId: this.userId,
        nextUserId: '',
        network_Id: this.ipAddress,
        terminal_Id: this.ipAddress,
        data: this.estimationDataForApproval.map(val => ({
          srNo: val?.SrNo,
          price: val?.PerUnitCost ? val?.PerUnitCost : 0,
          jeRemarks: val?.jeRemarks ? val?.jeRemarks : "",
          jeQuantity: val?.jeQuantity ? val?.jeQuantity : 0
        }))
      }
    ]

    this.submitEPCWork(reqBody);
  }

  submitEPCWork(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService
      .insertComponentPriceEPC(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });
            this.clearAllData();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For PV Submit', `${reqBody}`, new Date(), `${data}`);
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For PV Submit Error', `${reqBody}`, new Date(), `${err}`);
        },
      });
  }

  clearAllData() {
    this.selectedOutletToGetData = null;
    this.selectedBenefitedAreaToGetData = null;

    this.agreementNoList = [];
    this.agreementNoToGetData = null;

    this.chunkList = [];
    this.chunkIdToGetData = null;

    this.epcDataForApproval = [];
    this.epcDataForAppLandDetails = [];
    this.estimationDataForApproval = [];

    this.selectedJE = null;
    this.selectedStatus = null;
    this.remarks = null;
  }

  clickOnAppAction(val) {
    this.selectedFarmerApp = val;
    this.surveyArea = val?.TotalArea;
    this.showActionDialog = true;
    this.geoLocMulArray = [];
    this.geoLocMulArray.push([]);

    this.getCurrentLocation();
    this.addOverlay();
    this.refreshLocation = setInterval(() =>
    this.onRefreshCurrentLocation(), 6000)
  }


  onCloseActionDialog() {
    this.isGPSError = false;
    clearInterval(this.refreshLocation);
    this.showActionDialog = false;
    this.mapEnable = false;
    this.geolocationsarray = [];
    this.geoLocMulArray = [];
    this.overlays = this.overlays.filter(val => {
      return !val?.title?.includes('Coordinate')
    });
    this.documentList = [];
    // this.isPVSurveySubmitted = false;
    this.landArea = 0;
    this.surveyArea = null;
    this.addOverlay();
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  ngOnDestroy() {
    this.displayCameraComponent = false;

    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }


  onDeleteCoordinate(i, tableNo) {
    this.geoLocMulArray[tableNo].splice(i, 1);
    for (let index = 0; index <  this.geoLocMulArray[tableNo].length; index++) {
      this.geoLocMulArray[tableNo][index].CornerID = `Polygon  ${tableNo+1} : Coordinate  ${index + 1}` ;
    }    

    if(this.geoLocMulArray[tableNo].length > 0){
      this.onSave(tableNo);
    }else{
      this.onSave(0);
    }
    // }
  }

  onDeleteNewPolygon(i){
    this.geoLocMulArray
    if (i >= 0 && i < this.geoLocMulArray.length) {
      this.geoLocMulArray.splice(i, 1);
      
      // Renaming the remaining polygon corner IDs
      for (let j = 0; j < this.geoLocMulArray.length; j++) {
        for (let k = 0; k < this.geoLocMulArray[j].length; k++) {
          this.geoLocMulArray[j][k].CornerID = `Polygon ${j + 1} : Coordinate ${k + 1}`;
        }
      }

      this.onSave(0);

    } else {
      console.error("Index out of bounds");
    }
  }
  
  onStartNewPolygon(index){
    this.geoLocMulArray.push([]);
    this.cdr.detectChanges();
  }

  onCapture(index) {
    this.cdr.detectChanges();
    let instant = this;
    this.coordinateError = '';
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      function success(pos) {
        let isInvalid = instant.geoLocMulArray[index].find((data) => {
          if (
            data.lat == pos.coords.latitude &&
            data.lng == pos.coords.longitude
          ) {
            return data;
          }
        });

        if (isInvalid) {
          instant.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail:
              'Please move to a different location to get new coordinates.',
          });
          return;
        }

        const crd = pos.coords;
        const obj = {
          // CornerID: instant.geoLocMulArray[index].length + 1,
          CornerID: `Polygon  ${index+1} : Coordinate  ${instant.geoLocMulArray[index].length + 1}`,
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        instant.geoLocMulArray[index].push(obj);
        
        // Check for self-intersections before allowing the polygon creation
        if (instant.isSelfIntersecting(instant.geoLocMulArray[index])) {
          instant.geoLocMulArray[index].pop();
          alert('Polygon is invalid due to intersecting edges. Please redraw.');
          return;
        }else {
          instant.onSave(index);
        }
      }

      function error(err) {
        let detailsMsg = '';
        if(err?.message== 'User denied Geolocation'){
          detailsMsg = 'Please enable Geolocation access'
        } else{
          detailsMsg = 'Please capture again.'
        }
        instant.messageService.add({
          severity: 'error',
          summary: err.message,
          detail: detailsMsg
            ,
        });
      }

      navigator.geolocation.getCurrentPosition(success, error, options);
    }
  }

  isSelfIntersecting(coordsArray) {
    for (let i = 0; i < coordsArray.length - 1; i++) {
      for (let j = i + 2; j < coordsArray.length; j++) {
        // Prevent checking consecutive edges or the last edge with the first one
        if (i === 0 && j === coordsArray.length - 1) continue;
        if (this.doLinesIntersect(coordsArray[i], coordsArray[i + 1], coordsArray[j], coordsArray[(j + 1) % coordsArray.length])) {
          return true;
        }
      }
    }
    return false;
  }

  doLinesIntersect(p1, q1, p2, q2) {
    // Helper function to calculate orientation of the points
    function orientation(p, q, r) {
      let val = (q.lat - p.lat) * (r.lng - q.lng) - (q.lng - p.lng) * (r.lat - q.lat);
      if (val === 0) return 0; // collinear
      return (val > 0) ? 1 : 2; // clock or counterclockwise
    }

    // Check the four orientations needed for the general and special cases
    let o1 = orientation(p1, q1, p2);
    let o2 = orientation(p1, q1, q2);
    let o3 = orientation(p2, q2, p1);
    let o4 = orientation(p2, q2, q1);

    // General case
    if (o1 !== o2 && o3 !== o4) return true;

    // Special cases
    // p1, q1, p2 are collinear and p2 lies on segment p1q1
    if (o1 === 0 && this.onSegment(p1, p2, q1)) return true;

    // p1, q1, q2 are collinear and q2 lies on segment p1q1
    if (o2 === 0 && this.onSegment(p1, q2, q1)) return true;

    // p2, q2, p1 are collinear and p1 lies on segment p2q2
    if (o3 === 0 && this.onSegment(p2, p1, q2)) return true;

    // p2, q2, q1 are collinear and q1 lies on segment p2q2
    if (o4 === 0 && this.onSegment(p2, q1, q2)) return true;

    return false;
  }

  onSegment(p, q, r) {
    return q.lng <= Math.max(p.lng, r.lng) && q.lng >= Math.min(p.lng, r.lng) &&
      q.lat <= Math.max(p.lat, r.lat) && q.lat >= Math.min(p.lat, r.lat);
  }

  onSave(tableNo) {
    this.mapEnable = false;
    this.mapEnable = true;
    this.options.center = this.geoLocMulArray[tableNo][0];
    this.overlays = [];
    this.geoLocMulArray.forEach((arr, tableIndex) => {
      arr.forEach((row, index) => {
        this.addMarkers(row, index, tableIndex);
      });
    })
    
    this.addOverlay();
  }

  addOverlay() {
    this.overlays.forEach((val, index) => {
      if(val?.fillColor){
        this.overlays.splice(index, 1);
      }
    })

    this.geoLocMulArray.forEach(arr => {
      this.overlays.push(
        new google.maps.Polygon({
          paths: arr,
          strokeOpacity: 0.5,
          strokeWeight: 1,
          fillColor: '#1976D2',
          fillOpacity: 0.35,
        })
      );
    })
    

    let area = 0;
    this.geoLocMulArray.forEach(array => {
      if(array.length >= 3 ){
        let polygon = new google.maps.Polygon({paths: array});
        area += this.calculateLandArea(polygon.getPath());
      }
    });
    this.landArea = Number((0.000247105*area).toFixed(2));

    // if(this.geolocationsarray.length >=3){
    //   let polygon = new google.maps.Polygon({paths: this.geolocationsarray})
    //   let area = this.calculateLandArea(polygon.getPath());
    //   this.landArea = Number((0.000247105*area).toFixed(2));
    // }
    
    // this.onRefreshCurrentLocation();
  }

  // ==================================
  
  calculateLandArea(polygon){
    return google?.maps?.geometry?.spherical.computeArea(polygon)
  }

  removeOverlay() {
    this.overlays.pop().setMap(null);
  }
  
  addMarkers(row: any, index, tableNo) {  
    this.overlays.push(
      new google.maps.Marker({
        position: { lat: row?.lat, lng: row?.lng },
        title: `${row?.CornerID}`,
        // draggable: false,
        draggable: false,
        crossOnDrag: false
      })
    );
  }

  onDrag(event) {
    let indexVal = this.getTableAndCoordinateVal(event?.overlay?.title)


    let index = indexVal?.coordinateValue ? indexVal?.coordinateValue : 1;
    let tableNo = indexVal?.polygonIndex ? indexVal?.polygonIndex : 1;

    // index = event?.overlay?.title ? event?.overlay?.title.split(' ')[1] : -1;
    if (index >= 1) {
      this.geoLocMulArray[tableNo - 1][index - 1].lat = event?.overlay?.position?.lat();
      this.geoLocMulArray[tableNo - 1][index - 1].lng = event?.overlay?.position?.lng();

      this.removeOverlay();
      this.addOverlay();
    }
  }


  getTableAndCoordinateVal(val) {
    let polygonIndex = null; // Default to null if not present
    let coordinateValue = null; // Default to null if not present

    // Match both patterns
    const polygonMatch = val.match(/Polygon\s+(\d+)/);
    const coordinateMatch = val.match(/Coordinate\s+(\d+)/);

    // Extract polygon index if it exists
    if (polygonMatch) {
      polygonIndex = parseInt(polygonMatch[1], 10);
    }

    // Extract coordinate value if it exists
    if (coordinateMatch) {
      coordinateValue = parseInt(coordinateMatch[1], 10);
    }

    return { polygonIndex, coordinateValue };
  }
 

  onRefreshCurrentLocation() {
    this.overlays.forEach((val, index) => {
      if (val?.title == "Current Location") {
        this.overlays.splice(index, 1);
      }
    })
    this.getCurrentLocation();
  }

  getCurrentLocation() {
    let overlay = this.overlays;
    let mapEnable = this.mapEnable;
    let instant = this;
    this.coordinateError = '';
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      };

      function success(pos) {
        const crd = pos.coords;
        const obj = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        instant.options.center = obj;
        // const image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';

        const currentLocationMarker = new google.maps.Marker({
          position: { lat: obj?.lat, lng: obj?.lng },
          title: 'Current Location',
          icon: '../../../assets/map/location-icon-5.png',
        });

        overlay.push(currentLocationMarker)


        // instant.geolocationsarray.push(obj)
        // instant.onSave()
        // instant.addOverlay()
        instant.mapEnable = true;
      }

      function error(err) {
        instant.isGPSError = true;
        let detailsMsg = '';
        if (err?.message == 'User denied Geolocation') {
          detailsMsg = 'Please enable Geolocation access.'
        } else {
          detailsMsg = 'Please Refresh the Current Location.'
        }
        instant.messageService.add({
          severity: 'error',
          summary: err.message,
          detail: detailsMsg,
        });
      }

      // this.mapEnable = true;
      navigator.geolocation.getCurrentPosition(success, error, options);
      // this.addOverlay();
    }
  }

  selectPreSurveyData(event) { }

  // getImagesArray() {
  //   if (this.documentList.length == 0) {
  //     this.messageService.add({
  //       severity: 'error',
  //       summary: 'ERROR_MESSAGE',
  //       detail: 'Images are Mandatory',
  //     });
  //     return;
  //   } else {
  //     this.uploadOptions.forEach((option) => {
  //       if (option.code != 'others') {
  //         let filtered = this.documentList.filter((doc) => {
  //           return doc.document_type == option.name;
  //         });
  //         if (filtered?.length == 0) {
  //           this.messageService.add({
  //             severity: 'error',
  //             summary: 'Error Message',
  //             detail: 'Atleast one ' + option.name + ' is Needed!',
  //           });
  //           return;
  //         }
  //       }
  //     });
  //   }
  // }


  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.imageCaptured = true;
    this.pictureTaken.emit(webcamImage);
  }

  public cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public uploadPicture() {
    const arr = this.webcamImage.imageAsDataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    exifr
      .parse(this.webcamImage.imageAsDataUrl)
      .then((output) => {
      });

      const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file: File = new File([u8arr], this.selctedFileType + '.jpeg', {
      type: mime,
    });
    let data = new FormData();
    data.append('file', file);
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let phNo = JSON.parse(payload)?.sub;
    // this.route.queryParams
    //   .subscribe(params => {
    // if (params.autoId) {
    this._personalDetalSer
      .uploadFile(data, phNo, this.selctedFileType.code)
      .subscribe((resp: any) => {
        if (resp.statusCode == 200) {
          const fileName = `preEstimateSurvey_${new Date().getTime()}`;
          this.documentList.push({
            attachment: resp.data,
            attachmentRawUrl: this.webcamImage.imageAsDataUrl,
            document_type: this.selctedFileType.name,
            displayName: fileName,
            name: this.selctedFileType.name,
            // this.selctedFileType.code === 'farmer_photo'
            //   ? 'Farmer Photo'
            //   : this.selctedFileType.code === 'water_source'
            //     ? 'Water Source'
            //     : this.selctedFileType.code === 'land_photo'
            //       ? 'Land Photo'
            //       : this.selctedFileType.code === 'others'
            //         ? 'Others'
            //         : 'Component Photo',
            isUploaded: false,
          });

          // let documentListObject = {
          //   // 'appId': this.cryptoJsService.DecryptData(params.appId),
          //   'documentList': this.documentList
          // }
          // sessionStorage.setItem('documentList', JSON.stringify(documentListObject));
          this.selctedFileType = '';
          this.retake();
          this.displayCameraComponent = false;
        } else {
        }
        this.selctedFileType = '';
      });
    // });
  }

  retake() {
    this.imageCaptured = false;
  }
  onCaptureImage() {
    this.displayCameraComponent = true;
  }
  onCloseImageDialog() {
    this.displayCameraComponent = false;
    this.imageCaptured = false;
  }

  getImagesArray() {
    if (this.documentList.length == 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'ERROR_MESSAGE',
        detail: 'Images are Mandatory',
      });
      return;
    } else {
      this.uploadOptions.forEach((option) => {
        if (option.code != 'others') {
          let filtered = this.documentList.filter((doc) => {
            return doc.document_type == option.name;
          });
          if (filtered?.length == 0) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Atleast one ' + option.name + ' is Needed!',
            });
            return;
          }
        }
      });
    }
  }

  submitFarmerPVSurvey() {
    let existImage = true;
    // this.isPVSurveySubmitted = true;
    let geoCoordinateError = false;
      this.geoLocMulArray.forEach((array, index) => {
        if(array.length < 4){
          this.coordinateError = `Please provide atleast 4 GPS Coordinates for polygon ${index+1}`;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Please provide atleast 4 GPS Coordinates for polygon ${index+1}`,
          });
          geoCoordinateError = true;
        }
      })
      if (geoCoordinateError) {
        // this.coordinateError = 'PLEASE_PROVIDE_ATLEAST_4_GPS_COORDINATES';
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error Message',
        //   detail: 'Please provide atleast 4 GPS Coordinates',
        // });
        return;
      } 
      else if (this.landArea > 0 && (this.landArea - this.surveyArea > 0.1*this.landArea || this.surveyArea - this.landArea > 0.1*this.landArea)) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: `Difference between Calculated Area (${this.landArea}) and Survey Area (${this.surveyArea}) is more. Please recapture the coordinates.`,
        });
        return;
      } 
      else if (this.documentList.length == 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Images are Mandatory',
        });
        return;
      } else {
        this.uploadOptions.forEach((option) => {
          if (option.code != 'others') {
            let filtered = this.documentList.filter((doc) => {
              return doc.document_type == option.name;
            });
            if (filtered?.length == 0) {
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Atleast one ' + option.name + ' is Needed!',
              });
              existImage = false;
            }
          }
        });
        let attachemntArray = [];
        if (!existImage) {
          return;
        }
        for (let index = 0; index < this.documentList.length; index++) {
          const obj = {
            attachmentsDoc: this.documentList[index].attachment,
            documentType: this.documentList[index].document_type,
          };
          attachemntArray.push(obj);
        }
        // let geoCoordinates = [];
        // for (let index = 0; index < this.geolocationsarray.length; index++) {
        //   const gpsObj = {
        //     CornerID: index + 1,
        //     latitude: this.geolocationsarray[index].lat,
        //     longitude: this.geolocationsarray[index].lng,
        //   };
        //   geoCoordinates.push(gpsObj);
        // }

        let geoCoordinates: any []= [];
        this.geoLocMulArray.forEach((array) => {
          let val = array.map((val) => ({
            CornerID: val.CornerID,
            latitude: val.lat,
            longitude: val.lng,
            appId: this.selectedFarmerApp?.APP_ID,
            progId: JSON.stringify(this.selectedFarmerApp?.ProposedSystemId)
          }))
          geoCoordinates.push(val);
        })

        const dataObj = [
          {
            outletId: this.selectedOutletToGetData?.OutletId,
            conId: this.selectedOutletToGetData?.ContractorCode,
            agreementNo: this.agreementNoToGetData?.AgreementNo,
            chunkId: this.chunkIdToGetData?.ChunkId,
            userId: this.userId,
            network_Id: this.ipAddress,
            terminal_Id: this.ipAddress,
            insertServayAttachmentsEPC: attachemntArray.map(val => ({
              ...val,
              appId: this.selectedFarmerApp?.APP_ID,
              progId: this.selectedFarmerApp?.ProposedSystemId,
            })),
            gpsCoordinatesEPC: geoCoordinates,
          }
        ];

        this.submitFarmerPVSurveyData(dataObj);
      }
  }


  submitFarmerPVSurveyData(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService
      .insertGeoAndAttachmentsEPC(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });
            this.actionDialogData();
            this.showActionDialog = false;

            let outletId = this.selectedOutletToGetData?.OutletId;
            let contractorId = this.selectedOutletToGetData?.ContractorCode;
            let agreementNo = this.agreementNoToGetData?.AgreementNo;
            let chunkId = this.chunkIdToGetData?.ChunkId;
            this.getEPCFarmerDetails(agreementNo, outletId, chunkId);
            
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  actionDialogData(){
    this.geolocationsarray = [];
    this.geoLocMulArray = [];
    this.geoLocMulArray.push([]);

    this.documentList = [];
  }


  removeImg(i) {
    this.documentList.splice(i, 1);
  }


  viewportToPixels(value) {
    var parts = value.match(/([0-9\.]+)(vh|vw)/)
    var q = Number(parts[1])
    var side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
    return side * (q / 100)
  }

  clickOnEditApp(row){
    this.clickOnAppAction(row);

    let reqBody = {
      AppId: row?.APP_ID,
      ProgId: row?.ProposedSystemId,
      ChunkId: this.chunkIdToGetData?.ChunkId
    }
    this.getAppData(reqBody);
  }

  getAppData(reqBody) {
    this.loader.start();
    let sub = this.vendorService
      .getGeoAndAttachmentsEPC(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          // this.loading = false;
          
          if (data.ImagePathJE.length > 0 || data.listGPSCoordinatesJE.length > 0) {
            // this.imagePathJE = data.ImagePathJE;
            // this.listGPSCoordinatesJE = data.listGPSCoordinatesJE;

            // for (let index = 0; index < data.listGPSCoordinatesJE.length; index++) {
            //   let geoData = {
            //     CornerID: data.listGPSCoordinatesJE[index].CornerID,
            //     lat: data.listGPSCoordinatesJE[index].Latitude,
            //     lng: data.listGPSCoordinatesJE[index].Longitude,
            //   };
            //   this.geolocationsarray.push(geoData);
            // }
            // if (this.geolocationsarray.length == 0) {
            //   this.mapEnable = false;
            // } else {
            //   if (this.geolocationsarray && this.geolocationsarray.length > 0) {
            //     this.options.center = this.geolocationsarray[0];
            //   }
            //   this.mapEnable = true;
            //   // this.geolocationsarray.forEach((row, index) => {
            //   //   this.addMarkers(row, index);
            //   // });
            //   // this.addOverlay();
            // }

            if(data.listGPSCoordinatesJE.length > 0){
              let geoCoordinates: any []= [];
              data.listGPSCoordinatesJE.forEach((array) => {
                let val = array.map((val) => ({
                  CornerID: val.CornerID,
                  lat: val.Latitude,
                  lng: val.Longitude
                }))
                geoCoordinates.push(val);
              })

              this.geoLocMulArray = geoCoordinates;

              this.onSave(0);
            }
  
            for (let index = 0; index < data.ImagePathJE.length; index++) {
              let imagesData = {
                attachment: data.ImagePathJE[index].ImagePath,
                attachmentRawUrl: data.ImagePathJE[index].ImagePath,
                document_type: data.ImagePathJE[index].DocumentType,
                displayName: data.ImagePathJE[index].DocumentType,
                name: data.ImagePathJE[index].DocumentType,
              };
              this.documentList.push(imagesData);
            }
          }
          else {
            // this.imagePathJE = [];
            // this.listGPSCoordinatesJE = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }

          this.activityRecordService.activityRecord( this.userId, 'EPC PV Update (App details)', JSON.stringify(reqBody), new Date(), 'Success' );
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord( this.userId, 'EPC PV Update Error (App details)', JSON.stringify(reqBody), new Date(), `${err}` );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }
}